import { render } from "./ClientInventarioStock.vue?vue&type=template&id=4b3d45f4&scoped=true"
import script from "./ClientInventarioStock.vue?vue&type=script&lang=js"
export * from "./ClientInventarioStock.vue?vue&type=script&lang=js"

import "./ClientInventarioStock.vue?vue&type=style&index=0&id=4b3d45f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3d45f4"]])

export default __exports__